import { h, Component } from 'preact';
import { jsxWith } from '../utils/jsx.util';

export default class NMRepPhoneNumber extends Component {
  render() {
    return jsxWith(this.props.phoneNumber, phoneNumber => (
      <a href={`tel:${phoneNumber}`} className='nm-rep-card--phone'>
        {phoneNumber}
      </a>
    ));
  }
}
